import { Directive } from '@angular/core';

@Directive({
  selector: '[xpo-checkbox-group-horizontal], [xpoCheckboxGroupHorizontal] ',
  host: {
    class: 'xpo-CheckboxGroupHorizontal--wrap',
  },
})
export class XpoCheckboxGroupHorizontal {}
